"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    largeStep: Number,
    leftDragHandleTitle: String,
    max: Number,
    min: Number,
    orientation: String,
    rightDragHandleTitle: String,
    selectionEnd: Number,
    selectionStart: Number,
    smallStep: Number,
    tickPlacement: String,
    tooltip: Object,
    value: Array,

    // Events
    change: Function,
    slide: Function
};